export const SET_ANALYTICS_DATA = 'SET_ANALYTICS_DATA';


export const setAnalyticData = (analyticsData) => {
    return {
        type: SET_ANALYTICS_DATA,
        payload: analyticsData
    }
}